import {Injectable} from '@angular/core';
import {Graphql} from './graphql';
import {MeetingDto} from '../dto/meeting-dto';
import {createMeeting, retrieveMeetingById, retrieveMeetingsByMonth, updateMeeting} from '../graphql/meeting.graphql';

@Injectable({
  providedIn: 'root'
})
export class Meeting extends Graphql {

  public createMeeting(meeting: MeetingDto, fields: string[] = ['id']) {
    return this.mutation<MeetingDto>(createMeeting(fields), {meeting: meeting}, "createMeeting");
  }

  public updateMeeting(meeting: MeetingDto, fields: string[] = ['id']) {
    return this.mutation<MeetingDto>(updateMeeting(fields), {meeting: meeting}, "updateMeeting");
  }

  public retrieveMeetingsByMonth(month: number, year: number, fields: string[] = ['id']) {
    return this.query<MeetingDto[]>(retrieveMeetingsByMonth(fields), {
      month: month,
      year: year
    }, "retrieveMeetingsByMonth");
  }

  public retrieveMeetingById(id: string, fields: string[] = ['id']) {
    return this.query<MeetingDto>(retrieveMeetingById(fields), {id: id}, "retrieveMeetingById");
  }
}
